var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ratings"},[_c('span',{staticClass:"ps-rating"},_vm._l((5),function(item,index){return _c('i',{staticClass:"fa",class:[_vm.reviewRating > index ? '' : 'fa-star-o']})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }